import { render, staticRenderFns } from "./SelectionQuestion.vue?vue&type=template&id=6c16d4dd&scoped=true&"
import script from "./SelectionQuestion.vue?vue&type=script&lang=js&"
export * from "./SelectionQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SelectionQuestion.vue?vue&type=style&index=0&id=6c16d4dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c16d4dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
